import { render, staticRenderFns } from "./step1-notice.vue?vue&type=template&id=5ad5b465&scoped=true"
import script from "./step1-notice.vue?vue&type=script&lang=js"
export * from "./step1-notice.vue?vue&type=script&lang=js"
import style0 from "./step1-notice.vue?vue&type=style&index=0&id=5ad5b465&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5b465",
  null
  
)

export default component.exports